// src/modules/Storekeeper/ContainerScannerModal/Scanners/TSDScanner.jsx
import React, { useRef, useEffect } from "react";
import styles from "./TSDScanner.module.css";

/**
 * TSD-сканер: простой input, который принимает коды и вызывает onMarkScanned при Enter.
 * Используется в ContainerScannerModal, когда выбран режим "TSD Scanner".
 */
export default function TSDScanner({ onMarkScanned }) {
  const inputRef = useRef(null);

  // При монтировании — сразу фокус
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // Следим, чтобы input всегда был в фокусе
  useEffect(() => {
    const keepFocus = () => {
      if (inputRef.current && document.activeElement !== inputRef.current) {
        inputRef.current.focus();
      }
    };
    document.addEventListener("keydown", keepFocus);
    return () => document.removeEventListener("keydown", keepFocus);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const code = inputRef.current.value.trim();
      if (!code) return;

      try {
        onMarkScanned(code);
      } catch {
        // Ошибки обрабатываются в родителе
      }
      inputRef.current.value = "";
    }
  };

  const handleFocus = () => {
    // Ставим курсор в конец текста (важно для TSD-терминалов)
    setTimeout(() => {
      const el = inputRef.current;
      if (el) {
        const len = el.value.length;
        el.setSelectionRange(len, len);
      }
    }, 0);
  };

  return (
    <div className={styles.container}>
      <input
        type="text"
        ref={inputRef}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onTouchStart={(e) => e.preventDefault()}
        placeholder="Сканируйте код..."
        className={styles.input}
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
        inputMode="none"
      />
    </div>
  );
}
